import './App.css';
import {Navigation} from 'react-minimal-side-navigation';
import 'react-minimal-side-navigation/lib/ReactMinimalSideNavigation.css';
import { Routes, Route, useNavigate } from "react-router-dom"
import jwt_decode from "jwt-decode";

import AssetManagement from "./AssetManagement";
import CollectionReports from "./CollectionReports";
import CollectionManagement from "./CollectionManagement";
import CustomerManagement from "./CustomerManagement";
import Profile from "./Profile";

import {useEffect, useState} from "react";
import {getAssetTypes} from "./actions/asset_types";
import { useCookies } from 'react-cookie'

import { setAssetTypes } from "./reducers/asset_types";
import {useDispatch, useSelector} from "react-redux";
import {getStates} from "./actions/states";
import {setStates} from "./reducers/states";
import {getCustomers} from "./actions/customers";
import {setCustomers} from "./reducers/customers";
import {setAuth} from "./reducers/auth";
import {login} from "./actions/auth";
import {Button, TextField} from "@mui/material";
import {getCollections} from "./actions/collections";
import {setCollections} from "./reducers/collections";
import {userManagementRoles} from "./utilities/roles";
import UserManagement from "./UserManagement";


const navItems = [
  {title: 'Asset Management', itemId: 'AssetManagement'},
  {title: 'Collection Reports', itemId: 'CollectionReports'},
  {title: 'Collection Management', itemId: 'CollectionManagement'},
  {title: 'Customer Management', itemId: 'CustomerManagement'},
  {title: 'User Management', itemId: 'UserManagement'},
  {title: 'Profile', itemId: 'Profile'}
];

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [ username, setUsername ] = useState('');
  const [ password, setPassword ] = useState('');
  const [ postLoginDataLoadComplete, setPostLoginDataLoadComplete] = useState(false);
  const [ showUnableToLogin, setShowUnableToLogin ] = useState(false);
  const [ unableToLoginReason, setUnableToLoginReason ] = useState('');

  const auth = useSelector(state => state.auth.value );
  const [cookies, setCookie, removeCookie] = useCookies(['access_token']);

  useEffect(() => {
      if( cookies.access_token != null && auth.token == null ) {
          var decoded = jwt_decode(cookies.access_token);
          //console.log(decoded);
          if( Date.now() > parseInt(decoded.exp + "000")) {
              console.log("token expired.");
              removeCookie('access_token');
              navigate('/');
              dispatch(setAuth({ }));
          } else {
              console.log("token valid");
              dispatch(setAuth({token: cookies.access_token}));
          }
      } else {
          const fetchData = () => async (dispatch) => {
              if (auth.token != null) {
                  const assetTypes = await getAssetTypes(auth.token);
                  dispatch(setAssetTypes(assetTypes.data));
                  const states = await getStates(auth.token);
                  dispatch(setStates(states.data));
                  const customers = await getCustomers(auth.token);
                  dispatch(setCustomers(customers.data));
                  setPostLoginDataLoadComplete(true);
              }
          }
          dispatch(fetchData());
      }
  }, [auth, cookies, dispatch,navigate, removeCookie]);

  const handleLoginSubmit = async (e) => {
      e.stopPropagation();
      const auth = await login(username, password);
      if( auth.status === "error") {
          setShowUnableToLogin(true);
          setUnableToLoginReason(auth.message);
      } else {
          setCookie('access_token', auth.token, {path: '/'})
          dispatch(setAuth(auth));
      }
  }

  const handleLogout = async(e) => {
        e.stopPropagation();
        removeCookie('access_token');
        navigate('/');
        dispatch(setAuth({ }));
  }

  const refreshData = async (e) => {
      const updatedCustomers = await getCustomers(auth.token);
      dispatch(setCustomers(updatedCustomers.data));
      const updatedAssetTypes = await getAssetTypes(auth.token);
      dispatch(setAssetTypes(updatedAssetTypes.data));
      const updatedCollections = await getCollections(auth.token);
      dispatch(setCollections(updatedCollections.data));
      const updatedStates = await getStates();
      dispatch(setStates(updatedStates.data));
     //console.log(updatedCollections)

  }

  if( auth.token == null ) {
      const isLoggingIn = auth.token != null;
      return (
          // react login form
          <div style={{ display: "flex", flexDirection: "row", width: "100%", justifyContent: "center"}}>
              <div style={{ display: "flex", flexDirection: "column", width: 250}}>
                  <img src={process.env.PUBLIC_URL + '/cc-logo-new-150x137.png'} alt="Compucycle Logo" width={150} style={{margin: 25}}/>
                  <div style={{ margin: 10, padding: 5, borderRadius: 4, width: 200, display: showUnableToLogin ? undefined : "none", backgroundColor: "#FFDDDD", color: "red" , textAlign: "center"}}>{unableToLoginReason}</div>
                  <TextField disabled={isLoggingIn} onChange={(e) => setUsername(e.target.value)} style={{marginLeft: 10, marginTop: 10, width: 210}} id="login-username" label="Username" variant="outlined" value={username} />
                  <TextField disabled={isLoggingIn} onChange={(e) => setPassword(e.target.value)} style={{marginLeft: 10, marginTop: 10, width: 210}} id="login-password" label="Password" variant="outlined" type="password" value={password} />
                  <Button disabled={isLoggingIn} onClick={handleLoginSubmit} style={{marginLeft: 10, marginTop:10, marginBottom: 10, width: 200}} variant="contained" color="primary">Login</Button>
              </div>
          </div>
      );
  }
  let showUserManagement = false;
  try {
      var decoded = jwt_decode(cookies.access_token);
      showUserManagement = userManagementRoles.includes(decoded.user.role);
  } catch {}


  return (

      <div className="container" style={{ display: "flex", flexDirection: "row", width: "100%"}}>
          <div className="side" style={{width: '200px', display: 'flex', flexDirection: "column"}}>
              <img src={process.env.PUBLIC_URL + '/cc-logo-new-150x137.png'} alt="Compucycle Logo" width={150} style={{margin: 25}}/>
            <Navigation items={navItems.filter(x => (x.itemId !== 'UserManagement' || ( x.itemId === 'UserManagement' && showUserManagement)))} activeItemId='AssetManagement' onSelect={({itemId}) => {
                navigate(`/${itemId}`);
            }}/>
              <div style={{ display: "flex", flex: 1, flexDirection: "column", justifyContent: 'flex-end'}}>
                  <div style={{ display: "flex", flexDirection: "row", width: '100%', justifyContent: 'center'}}>
                      <Button onClick={refreshData} style={{marginLeft: 10, marginTop:10, marginBottom: 10}} variant="contained" color="primary" disabled={false}>Refresh Data</Button>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", width: '100%', justifyContent: 'center'}}>
                    <Button onClick={handleLogout} style={{marginLeft: 10, marginTop:10, marginBottom: 10}} variant="contained" color="primary" disabled={false}>Logout</Button>
                  </div>
              </div>
          </div>
          <div style={{width: "calc(100% - 200px)"}}>
          <Routes>
              <Route path="AssetManagement/:id?" element={<AssetManagement/>}/>
              <Route path="CollectionReports/:id?" element={<CollectionReports/>}/>
              <Route path="CollectionManagement/:id?" element={<CollectionManagement/>}/>
              <Route path="CustomerManagement/:id?" element={<CustomerManagement/>}/>

              {showUserManagement ? <Route path="UserManagement/:id?" element={<UserManagement/>}/> : null}
              <Route path="Profile" element={<Profile/>}/>
          </Routes>
          {!postLoginDataLoadComplete ? (
              <div style={{position: "fixed", top:0, bottom: 0, left: 0, right:0, backgroundColor: "#00000022", display: "flex", justifyContent: "center", alignItems: "center"}}>
                  <div className="lds-roller">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                  </div>
              </div>
          ): null}
          </div>

      </div>
  );
}

export default App;
